import eventTypesMap from "./eventTypesMap";
import sendAnalytics from "./sendAnalytics";
import { LIV_ANALYTICS_API } from "../../constants/_api";
import { _validActions } from "./_validActions";
import deviceInfo from './getDeviceInfo';

const analyticsMiddleware = store => next => action => {
    try {
        let type = action.type;
        if (_validActions.indexOf(type) !== -1) {
            type = "COMMON_ANALTYICS";
        }

        let eventAction = eventTypesMap[type];
        if (eventAction) {
            let eventData = eventAction(action, store);
            if (eventData?.payload) {
                eventData.payload = { ...eventData.payload, ...deviceInfo };
            }

            let state = store.getState();
            let token = state.Global.token;

            //SEND ANALYTICS TO BACKEND
            let url = `${LIV_ANALYTICS_API}`;
            sendAnalytics(url, token, eventData);
        }
    } catch (err) {
        //TODO SEND CRASH REPORTS TO BACKEND
        console.log(err);
    }

    return next(action);
};

export default analyticsMiddleware;
